module.exports = __webpack_public_path__ + "static/media/traffic-highlight.00c190c4.png";